<template>
  <div class="lg:mb-0 mb-base" v-if="fulfillment.products.length > 0">
    <div class="p-[20px] border border-solid border-steam rounded-[8px]">
      <span class="sm:text-[18px] text-[16px] tex-young-night">{{$t('Fulfilling with us?')}}</span>
      <p class="sm:text-[14px] text-[12px] text-industrial-revolution mt-[12px]">{{$t('We will automatically create a fulfillment order for you. Once pickup is requested, the fulfillment order is requested to ship.')}}</p>
      <div v-for="(item, index) in fulfillment.products" :key="index">
        <div class="grid grid-cols-2 sm:gap-4 gap-2 mt-[13px]">
          <div class="col-span-1">
            <p class="sm:text-[14px] text-[12px] text-young-night">{{ $t('Warehouse') }}</p>
            <p class="sm:text-[14px] text-[12px] text-industrial-revolution mt-1">{{ item.fulfillment_center.name }}</p>
          </div>
          <div class="col-span-1">
            <p class="sm:text-[14px] text-[12px] text-young-night">{{ $t('SKU') }}</p>
            <p class="sm:text-[14px] text-[12px] text-industrial-revolution mt-1">{{ item.product.sku }}</p>
          </div>
          <div class="col-span-1">
            <p class="sm:text-[14px] text-[12px] text-young-night">{{ $t('Quantity') }}</p>
            <p class="sm:text-[14px] text-[12px] text-industrial-revolution mt-1">{{ item.quantity }}</p>
          </div>
          <div class="col-span-1">
            <p class="sm:text-[14px] text-[12px] text-young-night">{{ $t('Flags') }}</p>
            <p class="sm:text-[14px] text-[12px] text-industrial-revolution mt-1">
              {{ item.flags && item.flags.length ? item.flags.join(', ') : 'N/A' }}
            </p>           
          </div>
        </div>
      </div>
      <div v-if="editable && fulfillment.products.length > 0" class="relative flex items-center justify-end mt-6">
        <div class="absolute add-products">
          <span class="text-sm font-medium py-1 px-2 rounded tooltip bg-white text-primary">{{$t('Add more products')}}</span>
        </div>
        <div class="p-1 flex self-center bg-primary rounded">
          <feather-icon @click="addProduct()" class="cursor-pointer" icon="PlusIcon" svgClasses="w-5 h-5 text-white" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {sendFulfillmentRequest} from '../../../http/axios/requestHelper.js'
import vSelect from 'vue-select'
import common from '../../../assets/utils/common.js'
import ShipbluVSelect from 'shipblu-vue-select'
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'

export default {
  props: ['merchantID', 'fulfillment', 'orderData', 'fulfillingCardLoading'],
  data () {
    return {
      editable: false,
      products: [],
      allProductsList: [],
      productCatalog: [],
      productFlags: [],
      fulfillmentCenters: [],
      searchVal: '',
      searchInProgress: false,
      searchedValue: ' ',
      outboundProducts: []
    }
  },
  watch: {
    'fulfillment.products': {
      handler (val) {
        const choosedProducts = []
        this.productCatalog = []
        this.allProductsList.forEach(element => {
          this.productCatalog.push(element)
        })
        val.forEach(item => {
          if (item.product && item.product !== null) {
            item.product.optionalLabel = `SKU: ${item.product.sku} . ${item.product.current_inventory_level} available`
            choosedProducts.push(item.product)
            if (this.$route.params.type === 'delivery-orders') {
              item.quantity = (item.quantity > item.product.current_inventory_level) ? item.product.current_inventory_level : item.quantity
            } else if (this.$route.params.type === 'returns' && this.outboundProducts && this.outboundProducts.length > 0) {
              this.outboundProducts[0].products.forEach(element => {
                val.forEach(item => {
                  if (item.product && (item.product.id === element.product.id)) {
                    item.product.max = element.quantity
                  }
                })
              })
              item.quantity = (item.quantity > item.product.max) ? item.product.max : item.quantity
            }
          }
        })
        for (let i = 0; i < choosedProducts.length; i++) {
          this.productCatalog.forEach(element => {
            if (element.id === choosedProducts[i].id) {
              this.productCatalog.splice(this.productCatalog.indexOf(element), 1)
            }
          })
        }
      },
      deep: true
    },
    'searchVal' (val) {
      if (val === '') {
        this.loadProductCatalog()
      }
    }
  },
  methods: {
    handleProductSearch (search) {
      this.searchVal = search.target ? search.target.value : search
      return common.manageSearch(search, this.loadProductsSearch, 1000)
    },
    loadProductsSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchVal) {
        return
      }
      if (this.searchVal) {
        this.loadProductCatalog()
      }
    },
    loadProductCatalog () {
      this.searchInProgress = true
      const url = `${this.$route.params.type === 'returns' ? `api/v1/fc/orders/outbound/?merchant=${this.merchantID}&status=shipped&search=${this.orderData.customer.phone}&limit=100` : `api/v1/fc/products/?merchant=${this.merchantID}&current_inventory_level__gt=0&search=${this.searchVal}&limit=100`}`
      sendFulfillmentRequest(true, false, this, `${url}`, 'get', null, true,
        (response) => {
          this.allProductsList = []
          if (this.$route.params.type === 'delivery-orders') {
            this.allProductsList = response.data.results
          } else {
            this.outboundProducts = response.data.results
            this.outboundProducts[0].products.forEach(element => {
              this.fulfillment.products.forEach(item => {
                if (item.product.id === element.product.id) {
                  item.product.max = element.quantity
                }
              })
              this.allProductsList.push(element.product)
            })
          }
          this.productCatalog = []
          this.allProductsList.forEach(element => {
            this.productCatalog.push(element)
          })
          for (let i = 0; i < this.fulfillment.products.length; i++) {
            this.productCatalog.forEach(element => {
              if (element.id === this.fulfillment.products[i].product.id) {
                this.productCatalog.splice(this.productCatalog.indexOf(element), 1)
              }
            })
          }
          this.allProductsList.map(item => {
            item.optionalLabel = `SKU: ${item.sku} . ${item.current_inventory_level} available`
          })
          this.searchedValue = this.searchVal
          this.fulfillingCardLoading = false
        }
      )
      this.searchInProgress = false
    },
    loadFulfillmentCenters () {
      sendFulfillmentRequest(true, false, this, 'api/v1/fc/fulfillment-centers/', 'get', null, true,
        (response) => {
          this.fulfillmentCenters = response.data.results
        }
      )
    },
    loadProductFlags () {
      sendFulfillmentRequest(true, false, this, 'api/v1/fc/flags/', 'get', null, true,
        (response) => {
          this.productFlags = response.data.results
        }
      )
    },
    addProduct () {
      this.fulfillment.products.push({
        fulfillment_center: '',
        product: '',
        flags: [],
        quantity: 1
      })
    }
  },
  components: {
    vSelect,
    ShipbluVSelect,
    ShipbluCard
  }
}
</script>

<style scoped>
.disabled-card {
  pointer-events: none;
}
.trash {
  position: absolute;
  bottom: 10px;
  right: 10px;
  border-radius: 5px;
}
</style>